// Mock data for JPJ Driving License Portal
// Note: License data has been migrated to MongoDB and is served via /api/licenses.
// This file now only holds news/services content that remains local for now.

export const mockNews = [
  {
    id: 1,
    date: "15 Mei 2025",
    title: "JPJ Lanjutkan Tempoh Pembaharuan Lesen Memandu Sehingga 31 Disember 2025",
    category: "Pengumuman",
    excerpt: "Jabatan Pengangkutan Jalan (JPJ) mengumumkan lanjutan tempoh pembaharuan lesen memandu bagi pemegang lesen yang tamat tempoh bermula dari 1 Januari 2020 sehingga 31 Disember 2025."
  },
  {
    id: 2,
    date: "10 Mei 2025",
    title: "Sistem MyJPJ Kini Dilengkapi Ciri-Ciri Baru Untuk Kemudahan Orang Awam",
    category: "Teknologi",
    excerpt: "Aplikasi MyJPJ telah dinaiktaraf dengan ciri-ciri baharu termasuk semakan lesen digital, e-wallet dan notifikasi automatik untuk pembaharuan lesen."
  },
  {
    id: 3,
    date: "05 Mei 2025",
    title: "Operasi Khas JPJ: 1,200 Kenderaan Berat Didapati Melebihi Berat",
    category: "Penguatkuasaan",
    excerpt: "Dalam operasi khas selama 3 hari di lebuh raya utama, JPJ berjaya mengesan 1,200 kenderaan berat yang melebihi had berat yang dibenarkan."
  },
  {
    id: 4,
    date: "28 April 2025",
    title: "JPJ Perkenalkan Lesen Memandu Digital Bermula Julai 2025",
    category: "Perkhidmatan Baharu",
    excerpt: "Mulai Julai 2025, pemegang lesen memandu di Malaysia boleh menggunakan lesen memandu digital melalui aplikasi MyJPJ sebagai pengganti lesen fizikal."
  }
];

export const mockQuickServices = [
  { id: 1, title: "Semak Lesen Memandu", icon: "CreditCard", url: "/semak-lesen", color: "#0066cc" },
  { id: 2, title: "Pembaharuan Lesen", icon: "RefreshCw", url: "/pembaharuan", color: "#0066cc" },
  { id: 3, title: "Semak Saman", icon: "AlertTriangle", url: "/semak-saman", color: "#cc0000" },
  { id: 4, title: "Bayar Saman", icon: "DollarSign", url: "/bayar-saman", color: "#cc0000" },
  { id: 5, title: "Pertukaran Lesen Asing", icon: "Globe", url: "/pertukaran", color: "#0066cc" },
  { id: 6, title: "Status Permohonan", icon: "Search", url: "/status", color: "#009900" },
  { id: 7, title: "Cari Cawangan JPJ", icon: "MapPin", url: "/cawangan", color: "#009900" },
  { id: 8, title: "Hubungi Kami", icon: "Phone", url: "/hubungi", color: "#666666" }
];

export const licenseClassDescriptions = {
  "B2": "Motorsikal Kapasiti Enjin Tidak Melebihi 250cc",
  "B": "Semua Jenis Motorsikal Termasuk Melebihi 250cc",
  "D": "Kenderaan Persendirian - Manual dan Automatik",
  "DA": "Kenderaan Persendirian - Automatik Sahaja",
  "C": "Kenderaan Barang Ringan Tidak Melebihi 3.5 Tan",
  "CA": "Kenderaan Barang Ringan Automatik Tidak Melebihi 3.5 Tan",
  "E": "Kenderaan Barang Berat Melebihi 3.5 Tan",
  "EB": "Bas Mini dan Bas Ringan",
  "PA": "Lesen Belajar Memandu (Provisional)"
};
